<!-- <nav class="sticky flex-col w-32 h-screen top-0">nawigacja</nav> -->
<ng-container *ngIf="isMobileView$ | async as isMobileView">
  <aside *ngIf="!isMobileView.state" class="sticky h-screen top-0">
    <ng-container *ngIf="user$ | async as user">
      <app-profile-box [userName]="user.userName" [provider]="provider$ | async"> </app-profile-box>
    </ng-container>
    <hr class="border-sky-grey-light my-6" />
    <app-navigation></app-navigation>
  </aside>
</ng-container>
<ng-scrollbar class="w-full h-auto">
  <main class="h-fit w-full">
    <app-shell-header [mobileNav$]="mobileNav$" (toggleNav)="toggleNav($event)"></app-shell-header>
    <ng-container *ngIf="initialFetch$ | async; else loading">
      <ng-container *ngIf="showMobileNav$ | async">
        <section class="bg-white z-10 absolute w-full">
          <ng-container *ngIf="user$ | async as user">
            <app-profile-box [userName]="user.userName" [provider]="provider$ | async"> </app-profile-box>
          </ng-container>
          <hr class="border-sky-grey-light my-6" />
          <app-navigation></app-navigation>
        </section>
      </ng-container>
      <router-outlet></router-outlet>
    </ng-container>
  </main>
</ng-scrollbar>

<ng-template #loading>
  <sky-spinner size="2xl" class="flex justify-center mt-12"></sky-spinner>
</ng-template>
